import React from 'react'

import type { IconProps } from './Icon'
import { ReactComponent as Logo } from 'assets/svg/icon-logo.svg'

const IconLogo = (props: IconProps): JSX.Element => {
  const title = 'icon-logo'
  const { className, id = title, name = title, ...others } = props

  const svgProps = { id, name }

  return (
    <div className={className}>
      <Logo {...svgProps} data-testid={title} {...others} />
    </div>
  )
}

export default IconLogo
